export type AuthMeResponse = {
  sub: string;
  userId: string;
  email: string;
  fullName: string | null;
  roles: string[];
};

export type UserRole = "secretary" | "manager" | "admin";
export type UserStatus = "invited" | "active" | "disabled";
export type LoginMethod = "google" | "password";

export type AppUser = {
  id: string;
  email: string;
  fullName: string | null;
  role: UserRole;
  status: UserStatus;
  loginMethod: LoginMethod;
  invitedAt: string | null;
  lastLoginAt: string | null;
};

/** Error code the backend returns (403) for identities that were never invited. */
export const NO_ACCESS_ERROR = "NoAccess";

export const canManageClientCompanies = (roles: string[] = []) =>
  roles.some((role) => role === "manager" || role === "admin");

export const canMaintainEmployees = (roles: string[] = []) =>
  roles.some(
    (role) =>
      role === "secretary" || role === "manager" || role === "admin",
  );

export const canExportReports = (roles: string[] = []) =>
  roles.some((role) => role === "manager" || role === "admin");

export const canManageUsers = (roles: string[] = []) =>
  roles.some((role) => role === "admin");
